import React, { useEffect, useRef } from 'react';

const AD_CLIENT = 'ca-pub-2020734510583972';

/**
 * AdUnit — renders a Google AdSense ad unit.
 *
 * Props:
 *   slot              – required – the data-ad-slot number from AdSense
 *   format            – 'auto' | 'fluid' | 'autorelaxed'  (default: 'auto')
 *   layoutKey         – for in-feed ads, e.g. "-64+e4+4c-j1+60"
 *   layout            – for in-article ads, e.g. "in-article"
 *   fullWidthResponsive – boolean, default true for 'auto' format
 *   style             – extra wrapper styles
 */
export function AdUnit({ slot, format = 'auto', layoutKey, layout, fullWidthResponsive = true, style = {} }) {
  const pushed = useRef(false);

  useEffect(() => {
    if (!slot || pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // Safe to ignore in dev
    }
  }, [slot]);

  if (!slot) return null;

  const insProps = {
    className: 'adsbygoogle',
    style: { display: 'block', ...(layout === 'in-article' ? { textAlign: 'center' } : {}) },
    'data-ad-client': AD_CLIENT,
    'data-ad-slot': slot,
    'data-ad-format': format,
  };

  if (layoutKey) insProps['data-ad-layout-key'] = layoutKey;
  if (layout)    insProps['data-ad-layout']     = layout;
  if (format === 'auto' && fullWidthResponsive) insProps['data-full-width-responsive'] = 'true';

  return (
    <div style={{ overflow: 'hidden', margin: '24px auto', ...style }}>
      <ins {...insProps} />
    </div>
  );
}
